export default {
  "account": {
    "curatedCollections": "Spravované zbierky",
    "curatedCollectionsInfo": "Nájdite nižšie všetky zbierky, ktorých ste správcami",
    "editProfile": "Upraviť profil",
    "likes": "Označenia Páči sa mi",
    "linkAccount": "Môj účet",
    "linkLogin": "Prihlásiť sa",
    "linkLoginJoin": "Prihlásiť sa/Zaregistrovať sa",
    "linkLogout": "Odhlásiť sa",
    "myProfile": "Môj profil",
    "notifications": {
      "loggedIn": "Teraz ste prihlásení. Vitajte!",
      "loggedOut": "Teraz ste odhlásení.",
      "noCollections": {
        "curated": "Zatiaľ ste nevybrali žiadne zbierky",
        "private": "Zatiaľ ste nevytvorili žiadne súkromné galérie",
        "public": "Zatiaľ ste nevytvorili žiadne verejné galérie"
      },
      "noLikedItems": "Zatiaľ ste žiadne položky neoznačili, že sa vám páčia"
    },
    "privateCollections": "Súkromné zbierky",
    "profile": "Moje označenia Páči sa mi a galérie",
    "profileSettings": "Nastavenia profilu",
    "publicCollections": "Verejné galérie",
    "settings": "Nastavenia",
    "title": "Môj účet"
  },
  "actions": {
    "accept": "Prijať",
    "cancel": "Zrušiť",
    "close": "zatvoriť",
    "continue": "pokračovať",
    "download": "Stiahnuť",
    "edit": "Upraviť",
    "feedback": "Spätná väzba",
    "goBack": "Späť",
    "goHome": "Prejsť na domovskú stránku",
    "learnMore": "Uč sa viac",
    "like": "Označenie Páči sa mi",
    "move": "Hýbať",
    "next": "Ďalšie",
    "pin": "Kolík",
    "preview": "Náhľad",
    "previous": "Predchádzajúce",
    "providedBy": "Poskytovateľ:  {provider}",
    "reject": "Odmietnuť",
    "save": "Uložiť",
    "send": "poslať",
    "share": "Zdieľať",
    "shareOn": "Zdieľať na sociálnej sieti {social}",
    "skip": "Preskočiť",
    "viewAt": "Zobraziť na adrese {link}",
    "viewDocument": "Zobraziť dokument"
  },
  "attribution": {
    "country": "Krajina:",
    "creator": "Autor:",
    "date": "Dátum:",
    "institution": "Inštitúcia:",
    "title": "Názov:"
  },
  "automatedCardGroup": {
    "item": "Nedávne položky",
    "organisation": "Organizácie",
    "place": "Miesta",
    "time": "Odporúčané storočia",
    "topic": "Odporúčané témy"
  },
  "blog": {
    "author": "Autor",
    "authors": "Autori",
    "blog": "Blog",
    "by": "od autora",
    "categories": "Kategórie",
    "category": "Kategória",
    "posts": "Blogové príspevky",
    "published": "Zverejnené {date}",
    "relatedPosts": "Súvisiace príspevky"
  },
  "cardLabels": {
    "organisation": "Organizácia",
    "person": "Osoba",
    "place": "Miesto",
    "theme": "Téma",
    "time": "Storočia",
    "topic": "Téma"
  },
  "clearAllFilters": "Vymazať všetky filtre",
  "collections": {
    "actions": {
      "edit": "Upraviť kolekciu",
      "update": "Aktualizovať kolekciu"
    },
    "fashion": {
      "facets": {
        "CREATOR": {
          "moreName": "dizajnéri",
          "name": "Dizajnér | Dizajnéri",
          "select": "Vyberte dizajnéri"
        },
        "proxy_dc_format": {
          "moreName": "techniky",
          "name": "Technika | Techniky",
          "select": "Vyberte techniky"
        },
        "proxy_dc_type": {
          "moreName": "typy položiek",
          "name": "Typ položky | Typy položiek",
          "select": "Vyberte typy položiek"
        },
        "proxy_dcterms_medium": {
          "moreName": "materiály",
          "name": "Materiál | Materiály",
          "select": "Vyberte materiály"
        }
      }
    },
    "form": {
      "description": "Popis"
    },
    "notifications": {
      "update": "Kolekcia bola aktualizovaná"
    }
  },
  "collectionsYouMightLike": "Zbierky, ktoré by sa vám mohli páčiť",
  "colourSwatch": "Farebná vzorkovník",
  "contentYouMightLike": "Obsah, ktorý by sa vám mohol páčiť",
  "contentfulManual": {
    "footerNavigation": {
      "MoreInfoLabel": "Ďalšie informácie",
      "about": "Informácie o zbierkach Europeana",
      "forDevelopers": "Pre vývojárov",
      "help": "Pomoc",
      "meetUs": "Spoznajte členov tímu",
      "provide": "Staňte sa poskytovateľom údajov",
      "subscribe": "Prihlásiť sa na odber newslettra",
      "terms": "Podmienky používania služby a zásady ochrany osobných údajov"
    },
    "headerNavigation": {
      "Collections": "Zbierky",
      "explore": "Objavujte",
      "teachers": "Učitelia"
    }
  },
  "curatedAutomatically": "Spravované automaticky spol. Europeana",
  "dateFilter": {
    "endDate": "Dátum ukončenia",
    "specificDate": "Konkrétny dátum",
    "startDate": "Dátum začiatku",
    "to": "do"
  },
  "debug": {
    "apiRequests": {
      "apiKeyLinkText": "Europeana API kľúč",
      "noRequests": "Na tejto stránke neboli použité žiadne požiadavky na rozhrania Europeana API.",
      "settingsPageLinkText": "stránku nastavení",
      "tip": "Tip: Ak už máte {apiKeyLink}, môžete ho zadať na stránke {settingsPageLink} a bude zahrnutý do týchto odkazov na žiadosti API.",
      "title": "Požiadavky API"
    },
    "debug": "Debug",
    "settings": {
      "form": {
        "apiKey": {
          "description": "Zadajte svoj kľúč Europeana API a použije sa v odkazoch na požiadavky API.",
          "label": "API kľúč"
        },
        "enabled": {
          "description": "Ak je povolená, ponuka ladenia sa zobrazí v päte stránky.",
          "label": "Povoliť ponuku ladenia"
        }
      },
      "title": "Nastavenia"
    }
  },
  "delete": "Vymazať",
  "depiction": "Zobrazenie {title}",
  "directions": {
    "left": "Vľavo",
    "right": "Vpravo"
  },
  "edmIsShownAtLinkAlt": "Zobrazenie na webovej stránke poskytovateľa",
  "entity": {
    "actions": {
      "cancel": "Zrušiť",
      "pin": "Pripnúť položku",
      "unpin": "Odopnúť položku",
      "viewPinned": "Pozrite si pripnuté položky"
    },
    "labels": {
      "entity": "Subjekt"
    },
    "notifications": {
      "deleted": "Galéria bola vymazaná.",
      "error": {
        "unpin": "Došlo k chybe pri odpájaní položky. Skúste to prosím znova alebo nahláste problém."
      },
      "pin": "Táto položka sa zobrazí v hornej časti zbierky „ {entity} “. Keď bude táto zmena viditeľná na stránke zbierky, upozorníme vás.",
      "pinLimit": {
        "body": "Zatiaľ môžete na prvú stránku pripnúť iba 24 položiek. Ak chcete túto položku pripnúť, odpojte inú a potom sa pokúste znova pripnúť túto položku.",
        "title": "Príliš veľa pripnutých položiek"
      },
      "pinned": "Položka bola pripnutá. Teraz je v hornej časti prvej stránky tejto zbierky. Zobrazenie pre všetkých môže trvať až 24 hodín.",
      "select": "Vyberte súvisiacu entitu, na ktorú chcete položku pripnúť/odopnúť.",
      "unpin": "Táto položka sa prestane zobrazovať v hornej časti zbierky „ {entity} “. Keď bude táto zmena viditeľná na stránke zbierky, upozorníme vás.",
      "unpinned": "Položka bola odopnutá. Už sa nenachádza v hornej časti prvej stránky tejto zbierky. Zmiznutie pre každého môže trvať až 24 hodín."
    }
  },
  "error": "Chyba",
  "errorMessage": {
    "galleryUnauthorised": {
      "description": "Nie je to možné, pretože súkromné galérie sú viditeľné iba pre ich tvorcu. Ak poznáte tvorcu galérie, požiadajte ho o zverejnenie galérie. Prípadne nahláste tento problém pomocou tlačidla spätnej väzby.",
      "metaTitle": "Galéria je neoprávnená",
      "title": "Ups! {newline} Snažíte sa zobraziť súkromnú galériu inej osoby."
    },
    "itemNotFound": {
      "description": "Môže to byť z nasledujúcich dôvodov: táto položka neexistuje alebo; bolo zrušené, pretože nezodpovedalo našim kritériám kvality, alebo; bola aktualizovaná a znovu publikovaná s novým jedinečným identifikátorom, v takom prípade skúste položku znova nájsť.",
      "metaTitle": "Položka sa nenašla",
      "title": "Ó nie! {newline} Túto položku sa nám nepodarilo nájsť."
    }
  },
  "exhibitions": {
    "chapters": "Kapitoly",
    "credits": "Autori",
    "currentChapter": "Aktuálna kapitola",
    "description": "Preskúmať naše výstavy",
    "exhibitions": "Výstavy"
  },
  "explore": "Preskúmať",
  "facets": {
    "COLOURPALETTE": {
      "moreName": "farby",
      "name": "Farba | Farby",
      "options": {
        "#000000": "Čierna",
        "#000080": "Námornícka modrá",
        "#00008B": "Tmavomodrá",
        "#0000CD": "Stredná modrá",
        "#0000FF": "Modrá",
        "#006400": "Tmavozelená",
        "#008000": "Webová zelená",
        "#008080": "Modrozelená",
        "#008B8B": "Tmavá azúrová",
        "#00BFFF": "Hlboká nebeská modrá",
        "#00CED1": "Tmavo tyrkysová",
        "#00FA9A": "Stredne jarná zelená",
        "#00FF00": "Zelená",
        "#00FF7F": "Jarná zelená",
        "#00FFFF": "Tyrkysový",
        "#191970": "Polnočná modrá",
        "#1E90FF": "Dodger Blue",
        "#20B2AA": "Svetlo morská zelená",
        "#228B22": "Lesná zelená",
        "#2E8B57": "Morská zelená",
        "#2F4F4F": "Tmavá bridlicovo šedá",
        "#32CD32": "Limetková zelená",
        "#3CB371": "Stredne morská zelená",
        "#40E0D0": "tyrkysová",
        "#4169E1": "Kráľovská modrá",
        "#4682B4": "Oceľovo modrá",
        "#483D8B": "Tmavá bridlicovo modrá",
        "#48D1CC": "Stredne tyrkysová",
        "#4B0082": "indigo",
        "#556B2F": "Tmavo olivová zelená",
        "#5F9EA0": "Kadetská modrá",
        "#6495ED": "Nevädza",
        "#663399": "Rebecca fialová farba",
        "#66CDAA": "Stredný akvamarín",
        "#696969": "Matná šedá",
        "#6A5ACD": "Bridlicová modrá",
        "#6B8E23": "Olivová fádna",
        "#708090": "Bridlica šedá",
        "#778899": "Svetlá bridlica šedá",
        "#7B68EE": "Stredne bridlicová modrá",
        "#7CFC00": "Trávniková zelená",
        "#7F0000": "Web gaštanová",
        "#7F007F": "Web fialová",
        "#7FFF00": "chartreuska",
        "#7FFFD4": "akvamarín",
        "#800000": "Gaštanová",
        "#800080": "Fialová",
        "#808000": "Olivová",
        "#808080": "Web šedá",
        "#87CEEB": "Nebesky modrá",
        "#87CEFA": "Svetlá obloha modrá",
        "#8A2BE2": "Modrá Fialová",
        "#8B0000": "Tmavo červená",
        "#8B008B": "Tmavo purpurová",
        "#8B4513": "Sedlová hnedá",
        "#8FBC8F": "Tmavo morská zelená",
        "#90EE90": "Svetlo zelená",
        "#9370DB": "Stredne fialová",
        "#9400D3": "Tmavofialová",
        "#98FB98": "Svetlo zelená",
        "#9932CC": "Tmavá orchidea",
        "#9ACD32": "Žltá zelená",
        "#A020F0": "Fialová",
        "#A0522D": "Sienna",
        "#A52A2A": "Hnedá",
        "#A9A9A9": "Tmavošedý",
        "#ADD8E6": "Svetlo modrá",
        "#ADFF2F": "Zelená Žltá",
        "#AFEEEE": "Svetlá tyrkysová",
        "#B03060": "Gaštanová",
        "#B0C4DE": "Svetlá oceľovomodrá",
        "#B0E0E6": "Prášková modrá",
        "#B22222": "tehla",
        "#B8860B": "Tmavá zlatobyľová",
        "#BA55D3": "Stredná orchidea",
        "#BC8F8F": "Ružová hnedá",
        "#BDB76B": "Tmavá kaki",
        "#BEBEBE": "šedá",
        "#C0C0C0": "Strieborná",
        "#C71585": "Stredná fialová červená",
        "#CD5C5C": "Indická červená",
        "#CD853F": "Peruánska",
        "#D2691E": "Čokoládová",
        "#D2B48C": "Opálená",
        "#D3D3D3": "Svetlo šedá",
        "#D8BFD8": "Farba bodliaka",
        "#DA70D6": "Orchidea",
        "#DAA520": "Zlatobyľová",
        "#DB7093": "Svetlá fialová červená",
        "#DC143C": "karmínová",
        "#DCDCDC": "Gainsboro",
        "#DDA0DD": "Slivková",
        "#DEB887": "Pieskovo hnedá",
        "#E0FFFF": "Svetlo azúrová",
        "#E6E6FA": "Levanduľová",
        "#E9967A": "Tmavá lososová",
        "#EE82EE": "Fialová",
        "#EEE8AA": "Bledá zlatá",
        "#F08080": "Svetlo koralová",
        "#F0E68C": "Hnedožltá",
        "#F0F8FF": "Alice modrá",
        "#F0FFF0": "Medová",
        "#F0FFFF": "Blankytová",
        "#F4A460": "Pieskovo hnedá",
        "#F5DEB3": "Farba pšenice",
        "#F5F5DC": "Béžová",
        "#F5F5F5": "Biela dymová",
        "#F5FFFA": "Mätová krémová",
        "#F8F8FF": "Biela",
        "#FA8072": "Lososová",
        "#FAEBD7": "Starožitná biela",
        "#FAF0E6": "Farba ľanu",
        "#FAFAD2": "Svetlá zlatobyľová",
        "#FDF5E6": "Farba stará čipka",
        "#FF0000": "červená",
        "#FF00FF": "Fuchsiová",
        "#FF1493": "Tmavo ružová",
        "#FF4500": "Oranžová Červená",
        "#FF6347": "Paradajková ",
        "#FF69B4": "Ružová",
        "#FF7F50": "Horúca ružová",
        "#FF8C00": "Tmavo oranžová",
        "#FFA07A": "Svetlá lososová",
        "#FFA500": "Oranžová",
        "#FFB6C1": "Svetlo ružová",
        "#FFC0CB": "Ružová",
        "#FFD700": "Zlatá",
        "#FFDAB9": "Broskyňová",
        "#FFDEAD": "Navajo biela",
        "#FFE4B5": "Mokasínová",
        "#FFE4C4": "Bisque",
        "#FFE4E1": "Misty Rose",
        "#FFEBCD": "Blanšírovaná mandľová",
        "#FFEFD5": "Papaya Whip",
        "#FFF0F5": "Levanduľová",
        "#FFF5EE": "Mušlová",
        "#FFF8DC": "Cornsilk",
        "#FFFACD": "Citrónová šifónová",
        "#FFFAF0": "Kvetinová biela",
        "#FFFAFA": "Snehová",
        "#FFFF00": "žltá",
        "#FFFFE0": "Svetlo žltá",
        "#FFFFF0": "Slonovinová",
        "#FFFFFF": "Biela"
      },
      "select": "Vyberte farby"
    },
    "COUNTRY": {
      "name": "Poskytujúca krajina",
      "options": {
        "Albania": "Albánsko",
        "Austria": "Rakúsko",
        "Belarus": "Bielorusko",
        "Belgium": "Belgicko",
        "Bosnia and Herzegovina": "Bosna a Hercegovina",
        "Bulgaria": "Bulharsko",
        "Croatia": "Chorvátsko",
        "Cyprus": "Cyprus",
        "Czech Republic": "Česká republika",
        "Denmark": "Dánsko",
        "Estonia": "Estónsko",
        "Europe": "Európa",
        "Finland": "Fínsko",
        "France": "Francúzsko",
        "Georgia": "Gruzínsko",
        "Germany": "Nemecko",
        "Greece": "Grécko",
        "Holy See (Vatican City State)": "Svätá stolica (Vatikánsky mestský štát)",
        "Hungary": "Maďarsko",
        "Iceland": "Island",
        "Ireland": "Írsko",
        "Israel": "Izrael",
        "Italy": "Taliansko",
        "Latvia": "Lotyšsko",
        "Lithuania": "Litva",
        "Luxembourg": "Luxembursko",
        "Macedonia": "Macedónsko",
        "Malta": "Malta",
        "Moldova": "Moldavsko",
        "Montenegro": "Čierna Hora",
        "Netherlands": "Holandsko",
        "Norway": "Nórsko",
        "Poland": "Poľsko",
        "Portugal": "Portugalsko",
        "Romania": "Rumunsko",
        "Russia": "Rusko",
        "Serbia": "Srbsko",
        "Slovakia": "Slovensko",
        "Slovenia": "Slovinsko",
        "Spain": "Španielsko",
        "Sweden": "Švédsko",
        "Switzerland": "Švajčiarsko",
        "Turkey": "Turecko",
        "Ukraine": "Ukrajina",
        "United Kingdom": "Spojené kráľovstvo",
        "United States of America": "Spojené Štáty Americké"
      },
      "select": "Vyberte poskytujúce krajiny"
    },
    "CREATOR": {
      "moreName": "tvorcovia",
      "name": "Tvorca | Tvorcovia",
      "select": "Vyberte tvorcov"
    },
    "DATA_PROVIDER": {
      "moreName": "inštitúcií",
      "name": "Inštitúcia",
      "select": "Vyberte inštitúcií"
    },
    "IMAGE_ASPECTRATIO": {
      "name": "Orientácia obrázka | Orientácie obrázkov",
      "options": {
        "landscape": "Na šírku",
        "portrait": "Na výšku"
      },
      "select": "Vyberte orientáciu obrázka"
    },
    "IMAGE_SIZE": {
      "name": "Veľkosť obrázka | Veľkosti obrázkov",
      "options": {
        "extra_large": "Extra veľký, 4 MP + (napr. 2688 x 1520 pixelov)",
        "large": "Veľký,  1 – 4 MP (napr. 1920 x 1080 pixelov)",
        "medium": "Stredný 0,5 – 1 MP (napr. 850 x 850 pixelov)",
        "small": "Malý, menej ako 0,5 MP (napr. 650 x 600 pixelov)"
      },
      "select": "Vyberte veľkosti obrázkov"
    },
    "LANGUAGE": {
      "name": "Jazyk",
      "options": {
        "ar": "Arabčina",
        "bg": "Bulharský",
        "bs": "Bosnianska",
        "ca": "Katalánčina",
        "cs": "Český",
        "cy": "Waleština",
        "da": "Dánsky",
        "de": "Nemčina",
        "el": "Grécky",
        "en": "Angličtina",
        "es": "Španielčina",
        "et": "Estónčina",
        "fi": "Fínsky",
        "fr": "Francúzsky",
        "ga": "Írsky",
        "gd": "Gaelčina",
        "he": "Hebrejčina",
        "hr": "Chorvátsky",
        "hu": "Maďarský",
        "is": "Islandský",
        "it": "Taliansky",
        "lt": "Litovský",
        "lv": "Lotyšský",
        "mk": "Macedónsky",
        "mt": "Maltčina",
        "mul": "Viaceré jazyky",
        "nl": "Holandský",
        "no": "Nórsky",
        "pl": "Poľský",
        "pt": "Portugalčina",
        "ro": "Rumunský",
        "ru": "Ruský",
        "sk": "Slovenská",
        "sl": "Slovinčina",
        "sq": "Albánsky",
        "sr": "Srbský",
        "sv": "Švédsky",
        "tr": "Turecký",
        "uk": "Ukrajinský"
      },
      "select": "Vyberte jazyky"
    },
    "MIME_TYPE": {
      "name": "Formát súboru | Formáty súborov",
      "options": {
        "text/plain": "Obyčajný text"
      },
      "select": "Vyberte formáty súborov"
    },
    "PROVIDER": {
      "moreName": "agregátory",
      "name": "Agregátor",
      "select": "Vyberte agregátory"
    },
    "REUSABILITY": {
      "name": "Môžem to znova použiť?",
      "options": {
        "open": "Áno",
        "permission": "Možno; získajte povolenie",
        "restricted": "Áno; s výhradami",
        "uncategorized": "Nekategorizované"
      },
      "select": "Vyberte, či to môžete použiť"
    },
    "TYPE": {
      "name": "Typ média",
      "options": {
        "3D": "3D",
        "IMAGE": "Obraz",
        "SOUND": "Zvuk",
        "TEXT": "Text",
        "VIDEO": "Video"
      },
      "select": "Vyberte typy médií"
    },
    "api": {
      "name": "Vyhľadávať",
      "options": {
        "fulltext": "Záznamy s plným textom",
        "metadata": "Výhradne záznamy s metaúdajmi"
      },
      "switch": "Vyhľadávanie len v obsahu položiek s plným textom",
      "switchMoreInfo": "V tejto zbierke si môžete vybrať, čo chcete vyhľadávať: ak je tento prepínač zapnutý, budete vyhľadávať v texte novín a dokumentov; ak je vypnutý, budete namiesto toho vyhľadávať v informáciách popisujúcich položku, rovnako ako vždy vo väčšine iných zbierok."
    },
    "button": {
      "apply": "Použiť",
      "cancel": "Zrušiť",
      "morefilters": "Viac filtrov",
      "reset": "Obnoviť",
      "showAll": "Zobraziť všetko {label}",
      "showLess": "Zobraziť menej {label}"
    },
    "collection": {
      "name": "Téma",
      "options": {
        "archaeology": "Archeológia",
        "art": "Umenie",
        "fashion": "Móda",
        "industrial": "Priemyselné dedičstvo",
        "manuscript": "Rukopisy",
        "map": "Mapy a geografia",
        "migration": "Migrácia",
        "music": "Hudba",
        "nature": "Prírodná história",
        "newspaper": "Noviny",
        "photography": "Fotografie",
        "sport": "Šport",
        "ww1": "Prvá svetová vojna"
      },
      "select": "Vyberte tému"
    },
    "contentTier": {
      "name": "Kvalita položky",
      "options": {
        "*": "Obsahuje položky, ktoré nespĺňajú naše publikačné kritériá",
        "0": "Zobraziť iba položky, ktoré nespĺňajú kritéria zverejnenia",
        "1": "Nízka kvalita",
        "2": "Stredná kvalita",
        "3": "Vysoká kvalita a opakované použitie s podmienkami",
        "4": "Vysoká kvalita a voľné opakované použitie"
      },
      "select": "Vyberte vlastnosti položky"
    },
    "moreOptions": "Hľadajte, aby ste našli {0} viac {1}.",
    "proxy_dc_format": {
      "name": "Formát | Formáty",
      "select": "Vyberte formáty"
    },
    "proxy_dc_type": {
      "name": "Typ | Typy",
      "select": "Vyberte typy"
    },
    "proxy_dcterms_issued": {
      "name": "Dátum vydania"
    },
    "proxy_dcterms_medium": {
      "name": "Médium | Mediá",
      "select": "Vyberte média"
    }
  },
  "feedback": {
    "emailOptional": "Možno budeme chcieť nadviazať ďalšie kroky. Ak chcete, aby sme vás kontaktovali, zadajte svoj e-mail.",
    "failed": "Žiadosť zlyhala. Prosím skúste znova.",
    "form": {
      "placeholders": {
        "email": "Zadajte svoju e-mailovú adresu",
        "feedback": "Sem zadajte svoju spätnú väzbu"
      }
    },
    "policies": "Pokračovaním súhlasíte s našimi {0} a beriete na vedomie naše {1}.",
    "privacyPolicy": "Zásady ochrany osobných údajov",
    "success": "Vaša spätná väzba bola odoslaná.",
    "termsOfService": "Podmienky služby",
    "thankYou": "Ďakujeme!",
    "title": "Odoslať spätnú väzbu",
    "validEmail": "Zadajte platnú e-mailovú adresu",
    "validFeedback": "Vaša spätná väzba musí obsahovať minimálne 5 slov"
  },
  "fieldLabels": {
    "default": {
      "dcContributor": "Prispievatelia",
      "dcCoverage": "Miesto-Čas",
      "dcCreator": "Tvorca",
      "dcDate": "Dátum",
      "dcDescription": "Popis",
      "dcDuration": "Trvanie",
      "dcFormat": "Formát",
      "dcIdentifier": "Identifikátor",
      "dcLanguage": "Jazyk",
      "dcPublisher": "Vydavateľ",
      "dcRelation": "Vzťahy",
      "dcRights": "Práva",
      "dcSource": "Zdroj",
      "dcSubject": "Predmet",
      "dcTitle": "Názov",
      "dcType": "Typ objektu",
      "dctermsCreated": "Dátum vytvorenia",
      "dctermsExtent": "Rozsah",
      "dctermsHasPart": "Pozostáva z",
      "dctermsHasVersion": "Má verziu",
      "dctermsIsFormatOf": "Je formát",
      "dctermsIsPartOf": "Je súčasťou",
      "dctermsIsReferencedBy": "Odkazuje sa naň v",
      "dctermsIsReplacedBy": "Nahrádza ho",
      "dctermsIsRequiredBy": "Vyžaduje sa od",
      "dctermsIssued": "Dátum vydania",
      "dctermsMedium": "Médium",
      "dctermsProvenance": "Proveniencia",
      "dctermsReferences": "Odkazy",
      "dctermsSpatial": "Miesta",
      "dctermsTOC": "Obsah",
      "dctermsTemporal": "Časové obdobie",
      "edmCountry": "Poskytujúca krajina",
      "edmCurrentLocation": "Aktuálna poloha",
      "edmDataProvider": "Poskytujúca inštitúcia",
      "edmHasMet": "Spĺňa",
      "edmIncorporates": "Zahŕňa",
      "edmIntermediateProvider": "Sprostredkovateľ",
      "edmIsDerivativeOf": "Je odvodený z",
      "edmIsRelatedTo": "Súvisí s",
      "edmIsRepresentationOf": "Znázorňuje",
      "edmIsSimilarTo": "Podobá sa",
      "edmIsSuccessorOf": "nasleduje po",
      "edmProvider": "Poskytovateľ",
      "edmRealizes": "Zachytáva",
      "edmRights": "Licencia na médiá v tomto zázname (pokiaľ nie je uvedené inak)",
      "edmUgc": "Obsah generovaný používateľmi",
      "europeanaCollectionName": "Názov zbierky",
      "keywords": "Kľúčové slová (poskytnuté komunitou)",
      "timestampCreated": "Vytvorenie časovej pečiatky",
      "timestampUpdate": "Aktualizácia časovej pečiatky",
      "wasPresentAt": "bol prítomný na mieste",
      "year": "Rok"
    },
    "webResource": {
      "about": "RDF o",
      "dcDescription": "Popis",
      "ebucoreHasMimeType": "Typ Ebucore MIME",
      "edmRights": "Licencia na tento mediálny zdroj",
      "rdfAbout": "RDF o"
    }
  },
  "filter": "Filter",
  "filterResults": "Filtrovať výsledky",
  "footer": {
    "customiseWebsiteLanguage": "Prispôsobenie jazyka webovej lokality",
    "disclaimerLine1": "Europeana je iniciatíva Európskej únie financovaná Connecting Europe Facility a členskými štátmi Európskej únie. Služby Europeany, vrátane tejto webovej stránky, prevádzkuje konzorcium vedené nadáciou Europeana na základe zmluvy o poskytovaní služieb s Európskou komisiou.",
    "disclaimerLine2": "Európska komisia nezaručuje presnosť informácií a neprijíma žiadnu zodpovednosť ani zodpovednosť za informácie na tejto webovej stránke. Európska komisia ani žiadna osoba konajúca v mene Európskej komisie nie je zodpovedná ani zodpovedná za presnosť alebo použitie informácií na tejto webovej stránke.",
    "findUsElsewhere": "Nájdite nás aj inde",
    "imageDescription": "Financované Európskou úniou",
    "navigation": {
      "MoreInfoLabel": "Ďalšie informácie",
      "about": "O nás",
      "accessibility": "Prístupnosť",
      "cookies": "Cookies",
      "forDevelopers": "Pre vývojárov",
      "help": "Pomoc",
      "privacy": "Zásady ochrany osobných údajov",
      "provide": "Staňte sa poskytovateľom údajov",
      "subscribe": "Prihlásiť sa na odber newslettra",
      "terms": "Podmienky používania"
    },
    "ourMission": "Náš cieľ",
    "ourMissionQuote": "Europeana posilňuje digitálnu transformáciu odvetvia kultúrneho dedičstva. Rozvíjame odborné znalosti, nástroje a zásady na prijímanie digitálnych zmien a nadväzujeme partnerstvá, ktoré sú založené na inovácii."
  },
  "formatting": {
    "ellipsis": "…",
    "listSeperator": ";"
  },
  "galleries": {
    "description": "Preskúmať naše galérie",
    "galleries": "Galérie"
  },
  "goToRecord": "Prejsť na záznam",
  "header": {
    "backToMenu": "Zatvoriť vyhľadávacie pole",
    "clearQuery": "Zmazať vyhľadávací dopyt",
    "closeSidebar": "Zavrieť ponuku",
    "entireCollection": "Hľadajte výraz {query} v celej našej zbierke",
    "europeanaHome": "Domovská stránka Europeana",
    "inCollection": "Hľadajte výraz {query} v zbierke {collection}",
    "navigation": {
      "about": "O nás",
      "collections": "Zbierky",
      "europeanaClassroom": "Pre učiteľov",
      "help": "Pomoc",
      "home": "Domov",
      "pro": "Pre profesionálov",
      "stories": "Príbehy"
    },
    "quickSearch": "Rýchle vyhľadávanie",
    "searchFor": "Vyhľadávať dopyt {query}",
    "searchForEverything": "Vyhľadávať všetko",
    "searchForEverythingInCollection": "Vyhľadávať všetko v zbierke {collection}",
    "searchForEverythingInEntireCollection": "Vyhľadávať všetko v celej našej zbierke",
    "searchForm": "Vyhľadávací formulár",
    "showSidebar": "Zobraziť ponuku",
    "sideNavigation": "Bočná navigácia"
  },
  "homeLinkAlt": "Domovská stránka Europeana",
  "homePage": {
    "discoverEditorial": "Najnovšie príbehy",
    "storiesCTA": "Zobraziť všetky príbehy",
    "subHeadline": "Vyhľadávajte, ukladajte a zdieľajte umenie, knihy, filmy a hudbu z tisícok kultúrnych inštitúcií",
    "themesCTA": "Zobraziť všetky témy",
    "themesTitle": "Preskúmajte podľa témy",
    "title": "Objavte {digital} kultúrne dedičstvo Európy",
    "titleDigital": "digitálne"
  },
  "imageSlider": {
    "handle": "Rukoväť posuvníka"
  },
  "items": {
    "itemCount": "1 položka | Počet položiek: {count}",
    "itemOf": "Max. {max} z {count} položiek",
    "recent": "Nedávne položky",
    "recommended": "Odporúčané položky",
    "youMightLike": "Položky, ktoré by sa vám mohli páčiť"
  },
  "klaro": {
    "main": {
      "acceptAll": "Prijať všetko",
      "acceptSelected": "Prijať vybrané",
      "consentModal": {
        "description": "Vaše súkromie údajov berieme vážne. Tu môžete posúdiť a prispôsobiť služby, ktoré by sme chceli použiť na tomto webe. Máte to na starosti! Povoľte alebo zakážte služby, ako uznáte za vhodné.",
        "title": "Služby, ktoré by sme chceli využiť."
      },
      "consentNotice": {
        "description": "Záleží nám na vašom súkromí a údaje používame iba na zlepšenie vášho zážitku. Na reklamu nepoužívame žiadne osobné informácie. Svoj súhlas môžete zmeniť každých 15 dní.",
        "learnMore": "Nechaj ma vybrať si"
      },
      "decline": "zamietam",
      "ok": "Dobre",
      "purposes": {
        "essential": {
          "description": "Tieto služby sú nevyhnutné pre správne fungovanie tejto webovej stránky. Zahŕňajú zobrazenie výsledkov vyhľadávania a jazykové predvoľby, zachovávajú prihlásený stav a zabezpečujú vašu návštevu. Nemôžete ich deaktivovať, pretože web by inak nefungoval správne.",
          "title": "Základné služby pre bezpečnosť a prispôsobenie"
        },
        "usage": {
          "description": "Tieto služby zhromažďujú informácie, ktoré nám pomáhajú lepšie pochopiť, ako sa webová stránka používa a kde sú body bolesti, čo nám umožňuje robiť informované rozhodnutia na zlepšenie vašich skúseností.",
          "title": "Služby na zaznamenávanie používania webových stránok a spätnej väzby"
        }
      },
      "service": {
        "disableAll": {
          "description": "Pomocou tohto prepínača môžete povoliť alebo zakázať všetky voliteľné služby.",
          "title": "Povoliť alebo zakázať všetky služby"
        }
      }
    },
    "services": {
      "abTest": {
        "description": "Pomáha zlepšovať náš web príležitostným použitím experimentálnych zmien.",
        "title": "A/B testovanie"
      },
      "auth-strategy": {
        "description": "Pamätá si stratégiu autorizácie, ktorá sa má použiť na prihlásenie.",
        "title": "Autentická stratégia"
      },
      "debugSettings": {
        "description": "Pomáha pri ladení požiadaviek API",
        "title": "Prepnúť ladenie"
      },
      "hotjar": {
        "description": "Aktivuje widget prieskumu, ktorý vám dáva možnosť odpovedať na naše prieskumy spokojnosti návštevníkov.",
        "title": "Hotjar"
      },
      "i18n": {
        "description": "Zapamätá si preferovaný jazyk rozhrania pre budúci prístup.",
        "title": "Kód jazyka"
      },
      "jira-servicedesk": {
        "description": "Aktivuje widget spätnej väzby a dáva vám možnosť nás kontaktovať.",
        "title": "Service Desk Jira"
      },
      "matomo": {
        "description": "Zhromažďuje anonymné štatistiky o tom, ako návštevníci interagujú s webovou stránkou.",
        "title": "Matomo"
      },
      "newFeatureNotification": {
        "description": "Zobrazí upozornenie, keď budú k dispozícii nové funkcie.",
        "title": "Oznámenie o novej funkcii"
      },
      "searchResultsView": {
        "description": "Pamätá si, či chcete radšej zobraziť výsledky vyhľadávania v zozname alebo mriežke.",
        "title": "Zobrazenie výsledkov hľadania (zoznam / mriežka)"
      }
    }
  },
  "layout": {
    "skipToMain": "Preskočiť na stránku s obsahom"
  },
  "learnMore": "Zistite viac o zdroji tohto popisu",
  "loading": "Načítava sa",
  "loadingResults": "Načítavajú sa výsledky",
  "messages": {
    "copyToClipboardSuccess": "Skopírované do schránky",
    "externalContentError": "Nepodarilo sa načítať externý obsah",
    "notFound": "Nenašlo sa",
    "paginationLimitExceeded": "Je možné zobraziť len prvých {limit} výsledkov vyhľadávania."
  },
  "modal": {
    "download": {
      "clickToCopy": "Kliknutím na atribút ho skopírujete",
      "modalIntro": "Ak používate túto položku na webe alebo kdekoľvek inde, nezabudnite vedľa nej zobraziť nasledujúce priradenie:",
      "modalTitle": "Povedz ďakujem"
    }
  },
  "multilingual": {
    "automated": "Automatizovaný preklad",
    "enrichment": "Obohatenie o partnerské projekty",
    "other": "Iné jazyky",
    "stopTranslating": "Zastaviť preklad tejto položky do jazyka {0}.",
    "translateLanguage": "Chceli by ste túto položku vidieť v položke {0}?",
    "translateQuotaError": "Prekladateľská služba je dočasne nedostupná. Skúste neskôr prosím."
  },
  "newFeatureNotification": {
    "dismiss": "Zatvoriť",
    "readMore": "Viac",
    "text": {
      "searchFilters": "Teraz môžete vyhľadávať hodnoty v jednotlivých filtroch; skontrolovať to!"
    }
  },
  "newWindow": "otvorí sa v novom okne",
  "noMoreResults": "Pre vaše vyhľadávanie neexistujú žiadne ďalšie výsledky.",
  "noResults": "Žiadne výsledky",
  "of": "Z",
  "organisation": {
    "city": "Mesto",
    "country": "Krajina",
    "englishName": "Anglický názov",
    "nameAcronym": "Názov akronym"
  },
  "pageHasLoaded": "načítal",
  "pageNumber": "Číslo strany",
  "pages": {
    "collections": {
      "organisations": {
        "table": {
          "name": "Názov"
        },
        "title": "Organizácie"
      },
      "persons": {
        "title": "Osoby"
      },
      "places": {
        "title": "Miesta"
      },
      "table": {
        "items": "Položky",
        "name": "Meno"
      },
      "times": {
        "title": "Krát"
      },
      "topics": {
        "title": "Témy"
      }
    }
  },
  "pagination": {
    "label": "Stránkovanie"
  },
  "readMore": "Viac",
  "recommendation": {
    "prompts": {
      "accept": "Palec hore pre pridanie do galérie",
      "reject": "Palec dole, ak sa vám nepáči"
    }
  },
  "record": {
    "IIIFViewer": "Divák IIIF",
    "actions": {
      "pin": "Pripnúť položku k dostupným entitám"
    },
    "allMetaData": "Všetky metadáta",
    "copyEmbedLabel": "Vložiť kód (kliknutím skopírujete)",
    "exploreMore": "Preskúmať viac",
    "extendedInformation": "Rozšírené informácie",
    "goodToKnow": "Dobré vedieť",
    "hideAll": "Skryť všetky informácie",
    "location": "Poloha",
    "locationOnMap": "Poloha na mape",
    "mediaPlayer": "Prehrávač médií",
    "record": "Záznam",
    "showAll": "Zobraziť všetky informácie",
    "similarItems": "Podobné položky",
    "status": {
      "unpublished": "[Nezverejnená položka]"
    },
    "transcription": "Prepis",
    "transcriptionDisclaimer": "Obsah pridáva verejnosť, nie inštitúcia, ktorá túto položku poskytla."
  },
  "related": {
    "editorial": {
      "title": "Príbehy, ktoré sa vám môžu páčiť"
    }
  },
  "relatedCollections": "Súvisiace zbierky",
  "removeFilter": "Odstrániť filter {filterLabel}",
  "reset": "Obnoviť",
  "resourceWikimedia": "Zdroj z Wikimedia Commons",
  "results": "Výsledky",
  "resultsFor": "Výsledky pre {0}",
  "resultsLimitWarning": "Ďalšie výsledky sa nezobrazujú, pretože sa zobrazuje iba prvých 1000 najrelevantnejších výsledkov. Ak ste nenašli, čo hľadáte, upresnite vyhľadávanie.",
  "resultsWithin": "Výsledky v rámci {0} {1} pre {2}",
  "search": {
    "boost": {
      "placeholder": "Zadajte dopyt na zvýšenie poľa"
    },
    "title": "Vyhľadávanie"
  },
  "searchHasLoaded": "{0} vrátené výsledky",
  "searchPlaceholder": "Vyhľadajte viac ako 50 miliónov položiek",
  "searchResults": "Vyhľadávať",
  "searchResultsFor": "{0} – vyhľadávať",
  "searchSuggestions": "Návrhy na vyhľadávanie",
  "searchTier": {
    "button": {
      "hide": "Skryť tieto položky",
      "show": "Zobraziť tieto položky"
    },
    "text": {
      "hide": "Zobrazia sa položky, ktoré nespĺňajú naše publikačné kritériá.",
      "show": "Vášmu vyhľadávaniu vyhovuje viac položiek, nespĺňajú však naše publikačné kritériá."
    }
  },
  "searchViews": {
    "grid": "Zobrazenie mriežky",
    "list": "Zobrazenie zoznamu",
    "mosaic": "Mozaikový pohľad"
  },
  "set": {
    "actions": {
      "addTo": "Pridať do galérie",
      "create": "Vytvoriť galériu",
      "createNew": "Vytvoriť novú galériu",
      "delete": "Vymazať galériu",
      "edit": "Upraviť galériu",
      "update": "Aktualizovať galériu"
    },
    "form": {
      "description": "Popis galérie",
      "private": "Túto galériu uložiť ako súkromnú",
      "required": "Povinné polia",
      "title": "Názov galérie"
    },
    "labels": {
      "curatedBy": "Zbierku spravuje",
      "private": "Súkromná galéria"
    },
    "notifications": {
      "deleted": "Galéria bola vymazaná.",
      "likeLimit": {
        "body": "Mrzí nás to, ale aktuálne môžete označiť maximálne 100 položiek, že sa vám páčia. Toto obmedzenie čoskoro odstránime!",
        "title": "100 označení Páči sa mi"
      },
      "updated": "Položka bola pridaná do galérie."
    },
    "prompts": {
      "delete": "Naozaj chcete vymazať túto galériu? Ak ju vymažete, stratíte všetky položky, ktoré ste do nej pridali."
    }
  },
  "showLess": "Zobraziť menej",
  "showMore": "Zobraziť viac",
  "sideFilters": {
    "noOptions": "Nie sú k dispozícii žiadne možnosti na výber",
    "search": "Vyhľadávanie"
  },
  "statuses": {
    "liked": "Obľúbené",
    "pinned": "Pripnuté"
  },
  "storiesPage": {
    "title": "Príbehy"
  },
  "website": "Webové stránky",
  "youMightAlsoLike": "Tiež sa vám môže páčiť"
};
